export const getReturnPath = state => state.rootReducer.ssoDetails.returnPath;
export const getReturnSearch = state => state.rootReducer.ssoDetails.returnSearch;
export const getSso = state => state.rootReducer.ssoDetails.sso;
export const getToken = state => state.rootReducer.ssoDetails.token;
